import React, { FC } from 'react';

import { useBusinessUnitsQuery } from 'Dictionary/query/dictionaryQuery';
import { mapToAutocompleteFieldItems } from 'Dictionary/model/BusinessUnit';
import {
  AutocompleteFieldItem,
  FormikAutocompleteField,
  FormikAutocompleteFieldProps,
} from 'components/FormikField/FormikAutocompleteField/FormikAutocompleteField';
import { useMyProfileQuery } from 'MyProfile/query/myProfile.query';

export interface BusinessUnitSelectFieldProps
  extends Omit<FormikAutocompleteFieldProps, 'label' | 'options'> {
  name: string;
  removePgUnitValue?: () => void;
  disabled?: boolean;
  divisionID?: number;
}

export const BusinessUnitSelectField: FC<BusinessUnitSelectFieldProps> = ({
  name,
  removePgUnitValue,
  disabled = false,
  divisionID,
  ...otherProps
}) => {
  const { data = [], isLoading, refetch } = useBusinessUnitsQuery(Number(divisionID ?? 0));
  const { data: userData } = useMyProfileQuery();
  const isAdmin = userData?.isAdmin;
  const allowedDivisionCodes = !userData?.isAdmin && userData?.roles
    ? userData?.roles
      .filter(r => r.type === 'LocalAdministrator')
      .flatMap(r => r.details?.map(d => d.description1))
      .filter(Boolean)
    : [];
  const localAdminRole = userData?.roles?.find((r) => r.type === 'LocalAdministrator');
  const isLocalAdmin = !!localAdminRole;
  const filteredData = (data ?? []).filter((d) => allowedDivisionCodes!.includes(d.description));
  const allowedDivisionObjects = filteredData.map((display) => ({
    id: display.id,
    name: display.description,
  }));
  const shouldDisableDivision = isAdmin ? true : !isLocalAdmin;
  let selectedOption: AutocompleteFieldItem[]
  if (!shouldDisableDivision) {
    selectedOption = allowedDivisionObjects
  } else {
    selectedOption = mapToAutocompleteFieldItems(data)
  }
  return (
    <FormikAutocompleteField
      name={name}
      label="Division"
      disabled={disabled}
      options={selectedOption}
      loading={isLoading}
      onOpen={() => refetch()}
      onFieldChange={removePgUnitValue}
      required
      {...otherProps}
    />
  );
};
